import { render, staticRenderFns } from "./StudentResetPassword.vue?vue&type=template&id=8c4a6170&scoped=true&"
import script from "./StudentResetPassword.vue?vue&type=script&lang=js&"
export * from "./StudentResetPassword.vue?vue&type=script&lang=js&"
import style0 from "./StudentResetPassword.vue?vue&type=style&index=0&id=8c4a6170&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c4a6170",
  null
  
)

export default component.exports